// extracted by mini-css-extract-plugin
export default {"browseButtonWrap":"FileUpload_browseButtonWrap__+jMsg","customFileInput":"FileUpload_customFileInput__iOfoZ"};